'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBoxTags', ['NotesQueryManagementService', '$controller', '$compile', function (NotesQueryManagementService, $controller, $compile) {
      return {
        restrict: 'A',
        scope: {
          managementId: '@'
        },
        link: function(scope, elem) {

          var _getEnabledTagTitles = function() {
            return lodash.map(
              lodash.filter(scope.tags, function(e) {return e.enabled;}),
              'tag');
          };

          scope.tags = lodash.map(
            ['scheduling', 'maintenance', 'foh', 'boh', 'health'],
            function(e) {return {tag: e, enabled: false}}
          );
          scope.toggleTag = function(idx) {
            scope.tags[idx].enabled = !scope.tags[idx].enabled;
            var q = baseCtrl.getQuery();
            q.tags = _getEnabledTagTitles();
            baseCtrl.setQuery(q);
          };

          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          function render(existingQuery) {
            // Sync tag states
            lodash.each(scope.tags, function(tag, index) {
              var present = lodash.include(existingQuery.tags || [], tag.tag);
              scope.tags[index].enabled = !!present;
            });

            // Compile
            $(elem).html(
              $compile('<div class="sa-note-query-box-tags"><div ng-repeat="tag in ::tags" class="tag-pill query-box-tag" ng-class="{\'enabled\': tag.enabled}" ng-click="toggleTag($index)">#{{tag.tag}}</div></div>')
                (scope)
            );
          }

          baseCtrl.initialize('QueryBoxTags', scope.managementId);
          baseCtrl.setRenderCallback(render);
          baseCtrl.updateMyself();

          scope.$on('$destroy', function() {
            baseCtrl.uninitialize();
            baseCtrl = undefined;
          });

        }
      }
    }]);
